import { Component, OnInit, Input, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { filter, map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { BaseCoreState, baseAssignmentsSelectors, baseAssignmentsActions, BaseButtonSize, CommentResponse } from 'base';

@Component({
  selector: 'base-customer-work-council-comments',
  templateUrl: './base-customer-work-council-comments.component.html',
})
export class BaseCustomerWorkCouncilCommentsComponent implements OnInit, OnDestroy {
  @ViewChild('commentListRef') commentListRef: ElementRef;
  @Input() offerId?: number;

  workCouncilComments: CommentResponse[] = [];
  workCouncilCommentControl = new FormControl('', {
    nonNullable: true,
    validators: [Validators.required, Validators.maxLength(255)],
  });
  submitted = false;
  buttonSize = BaseButtonSize;

  private destroy$ = new Subject<boolean>();

  constructor(private store: Store<BaseCoreState>) {}

  ngOnInit() {
    this.store
      .select(baseAssignmentsSelectors.getWorkCouncilComments)
      .pipe(
        takeUntil(this.destroy$),
        filter((data) => !!data.ok),
        map((value) => value.data as CommentResponse[])
      )
      .subscribe((comments) => {
        this.workCouncilComments = comments;
        setTimeout(() => this.scrollToBottom(), 0);
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  trackByCommentDate(_: number, comment: CommentResponse) {
    return comment.createdAt;
  }

  sendComment(event: MouseEvent) {
    event.preventDefault();

    if (!this.offerId) {
      return;
    }

    this.submitted = true;

    if (this.workCouncilCommentControl.invalid) {
      return;
    }

    this.store.dispatch(
      baseAssignmentsActions.createWorkCouncilComment({
        payload: {
          offer: this.offerId,
          body: {
            comment: this.workCouncilCommentControl.value.trim(),
          },
        },
      })
    );

    this.workCouncilCommentControl.reset();
    this.submitted = false;
  }

  scrollToBottom(): void {
    if (this.commentListRef?.nativeElement) {
      const element = this.commentListRef.nativeElement;
      element.scrollTo({
        top: element.scrollHeight,
        behavior: 'smooth',
      });
    }
  }
}
